var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMedium = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.3 4.286c0-1.097.889-1.986 1.986-1.986h15.428c1.097 0 1.986.89 1.986 1.986v15.428a1.986 1.986 0 0 1-1.986 1.986H4.286A1.986 1.986 0 0 1 2.3 19.714V4.286ZM4.286 3.7a.586.586 0 0 0-.586.586v15.428c0 .324.262.586.586.586h15.428a.586.586 0 0 0 .586-.586V4.286a.586.586 0 0 0-.586-.586H4.286Zm3.157 5.143H6.214v-1.4h2.279L12 12.119l3.507-4.676h2.278v1.4h-1.228v6.314h1.229v1.4h-3.858v-1.4h1.229v-4.914L12 14.453l-3.157-4.21v4.914h1.228v1.4H6.214v-1.4h1.229V8.843Z",
  fill: "currentColor"
})));
export { SvgMedium as ReactComponent };
export default __webpack_public_path__ + "b6afd6c18fd8939709f5514c3074c3db.svg";